const { TabContext, TabList, TabPanel } = require("@material-ui/lab");
const { Box, Tab, styled } = require("@mui/material");
const { useEffect } = require("react");
const { useState } = require("react");
const { default: IcpInspectionList } = require("./IcpInspectionList");

const StyledTabPanel = styled(TabPanel)(({theme}) => {
    return ({
        [theme.breakpoints.down('md')]: {
            "&.MuiTabPanel-root": {
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    })
})


/**
 * 
 * @param {object} props E.g. {
 * tabData {object} E.g. {'Ready': {inspections: [{...}, ...], loading: true}, 'Recently Inspected': {...}] 
 * searchFilter {string} filter inspections by ICP number or address.
 * 
 * @returns JSX component
 */
export function InspectionListTabs({tabData, searchFilter}) {

    const [tabValue, setTabValue] = useState('0')
    const [filteredTabData, setFilteredTabData] = useState({...tabData})

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {

        const filterInspections = (inspectionsList) => {
            const filteredInspectionsList = inspectionsList.filter((inspection) => {
                if (!searchFilter || searchFilter.length < 3) {
                    return true // Show everything if the search filter is less than 3 characters
                }

                const isSearchICPDigits = (searchFilter.replace(/[0-9A-FNR]*/g, '').length === 0) // Matches E.g. 0000573617NR4B9

                if (inspection.icpNo && isSearchICPDigits) {
                    const icpMatch = inspection.icpNo.includes(searchFilter)
                    if (icpMatch) {
                        return true
                    }
                }
                if (inspection.streetAddress) {
                    const addressMatch = inspection.streetAddress.toLowerCase().includes(searchFilter.toLowerCase())
                    if (addressMatch) {
                        return true
                    }
                }
                return false
            })
            return filteredInspectionsList
        }

        const newTabData = JSON.parse(JSON.stringify(tabData)) // deep copy
        const newFilteredInspections = newTabData?.Ready?.inspections.filter(inspection => inspection.registryStatus === 'New')
        const readyFilteredInspections = newTabData?.Ready?.inspections.filter(inspection => inspection.registryStatus !== 'New')

        console.log("newFilteredInspections:", newTabData['Not Ready'] )

        const array = { // /bff/icp-livening-service/api/new-connections/get-livening-work-orders-by-status
            'Livening Ready': {
                inspections: readyFilteredInspections,
                loading: newTabData.Ready.loading 
            },           
            'Livening Not Ready': {
                inspections: newFilteredInspections,//0000573277NR748 
                loading: newTabData.Ready.loading 
            },
            'Inspected Recently': {
                inspections: newTabData['Inspected Recently'].inspections,
                loading: newTabData['Inspected Recently'].loading 
            },
        }
        console.log("livening registry array: ", array)
        

        Object.entries(array).forEach(([tabName, {inspections, loading}], index) => {
            array[tabName].inspections = filterInspections(inspections)
        })
        setFilteredTabData(array)

        const nameOfFirstTabWithContent = Object.keys(array).find((tabName) => array[tabName].inspections.length > 0)
        const inxedOfFirstTabWithContent = nameOfFirstTabWithContent ? Object.keys(array).indexOf(nameOfFirstTabWithContent) : 0
        setTabValue(inxedOfFirstTabWithContent.toString())

    }, [tabData, searchFilter])

    return (

        <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabChange} indicatorColor="primary">
                {
                    Object.entries(filteredTabData).map(([tabName, {inspections, loading}], index) => {
                        const tabLabel = `${tabName} (${inspections.length})`
                        return (
                            <Tab key={tabName} label={tabLabel} value={index.toString()} disabled={!inspections.length} />
                        )
                    })
                }
                </TabList>
            </Box>
            {
                Object.entries(filteredTabData).map(([tabName, {inspections, loading}], index) => {
                    return (
                        <StyledTabPanel key={tabName} value={index.toString()}>
                            <IcpInspectionList title={tabName}  inspections={inspections} loading={loading} />
                        </StyledTabPanel>
                    )
                })
            }
        </TabContext>

    )
}